<template>
    <div class="bg-dim flex-col" v-if="modalOpen" @click="$emit('modalClose')">
        <!-- <div class="grow h-101"></div> -->
        <div @click.stop="">
            <div class="present-wrap">
                <em>선물 받는 분</em>
                <input type="text" placeholder="이름 (필수)"
                       :value="giftRequestInfo.receiverName"
                       @input="receiverNameBind"/>
                <input type="text" placeholder="휴대폰번호 (필수)"
                       :value="giftRequestInfo.receiverPhoneNumber"
                       @input="receiverPhoneNumberBind"
                       @keyup="setDash"
                       maxlength="13"/>
                <p><span class="gray-dot"></span>받는 분의 이름과 휴대폰 번호를 정확히 입력해주세요.</p>
                <em>선물 메세지 입력</em>
                <div class="text-box">
                    <textarea cols="50" maxlength="100" placeholder="감사한 마음을 담아 선물을 드립니다."
                              :value="giftRequestInfo.giftMessage"
                              @keyup="giftMessageCount($event)" />
                    <span>({{giftMessageLength}}/100)</span>
                </div>
              <div class="button-wrap">
                <button class="button-bg-yellow" @click="goGiftEventButton()">선물하기</button>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';

export default {
  name: 'Present',
  components: {BottomButton},
  props: {
    modalOpen: Boolean,
  },
  data() {
    return {
      /** @type {Object}  선물요청정보 객체 */
      giftRequestInfo : {
        /** @type {String} 선물 받는 분의 이름 */
        receiverName : '',
        /** @type {String} 선물 받는 분의 핸드폰 번호 */
        receiverPhoneNumber : '',
        /** @type {String} 선물메세지 */
        giftMessage : '',
      },
      /** @type {Number} 선물메세지 글자수 */
      giftMessageLength : 0,
    }
  },
  methods:{
    /**
     * 선물받는 사람의 이름을 바인딩하는 메소드
     * @param e  태그의 event
     */
    receiverNameBind(e){
      this.giftRequestInfo.receiverName = e.target.value;
    },

    /**
     * 선물받는 사람의 핸드폰번호를 바인딩하는 메소드
     * @param e 태그의 event
     */
    receiverPhoneNumberBind(e){
      this.giftRequestInfo.receiverPhoneNumber = e.target.value;
    },
    /**
     * 핸드폰 번호 입력란에 사용자가 번호를 입력하면
     * 자동으로 '-' 를 입력해주는 함수
     * @param e  태그의 event
     */
    setDash(e){
      let inputNumber = e.target.value.replace(/[^0-9]/g, '');
      let tmp = '';
      if( inputNumber.length < 4){
        this.giftRequestInfo.receiverPhoneNumber =  inputNumber;
      }else if(inputNumber.length < 7){
        tmp += inputNumber.substr(0, 3);
        tmp += '-';
        tmp += inputNumber.substr(3);
        this.giftRequestInfo.receiverPhoneNumber =  tmp;
      }else if(inputNumber.length < 11){
        tmp += inputNumber.substr(0, 3);
        tmp += '-';
        tmp += inputNumber.substr(3, 3);
        tmp += '-';
        tmp += inputNumber.substr(6);
        this.giftRequestInfo.receiverPhoneNumber =  tmp;
      }else{
        tmp += inputNumber.substr(0, 3);
        tmp += '-';
        tmp += inputNumber.substr(3, 4);
        tmp += '-';
        tmp += inputNumber.substr(7);
        this.giftRequestInfo.receiverPhoneNumber =  tmp;
      }
    },
    /**
     * 선물글자수를 체크하고 data에 바인딩하는 메소드
     * @param e  태그의 event
     */
    giftMessageCount(e){
      this.giftRequestInfo.giftMessage = e.target.value;
      this.giftMessageLength = e.target.value.length;
      if(e.target.value.length === 100){
        alert('메세지는 최대 100자 입니다.')
      }
    },
    /**
     * 부모 컴포넌트(productDetail.vue)로 데이터를 보냄
     */
    goGiftEventButton(){
      this.$emit("goGiftEvent", "GIFT", this.giftRequestInfo);
    },

  }
};
</script>

<style lang="scss" scoped>
    @import '/src/assets/styles/global.scss';
    .absolute { position: absolute; left: 0; bottom:0;  width: 100%; margin-top: rem(32);}
    .precent-wrap {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 70vh;
        padding: rem(40) rem(20) rem(0);
        border-radius: rem(24) rem(24) 0 0;
        background-color: $color-white;
        overflow-y: scroll;
        z-index: 100;
        em {
            display: block;
            margin-bottom: rem(16);
            @include font-size(rem(16), rem(24), 700);
            letter-spacing: -0.8px;
            color: $color-black;
        }
        input {
            width: 100%;
            padding: rem(16);
            margin-bottom: rem(8);
            border: 1px solid $color-gray-500;
            border-radius: rem(6);
            @include font-noto-sans; 
            @include font-size(rem(16), rem(0), 400);
            line-height: normal;
            color: $color-black-400;
            &:last-of-type { margin-bottom: 0;}
        }
        p { 
            display: flex;
            align-items: center;
            margin-top: rem(12);
            margin-bottom: rem(20);
            @include font-size(rem(13), rem(21), 400);
            color: $color-black-100;
        }
    }
    .text-box {
        width: 100%;
        padding: rem(16);
        border: 1px solid $color-gray-500;
        border-radius: rem(6);
        textarea {
            box-sizing: border-box;
            width: 100%;
            height: rem(79);
            resize: none;
            border-style: none;
            @include font-size(rem(14), rem(0), 400);
            @include font-noto-sans;
            line-height: normal;
            color: $color-primary-gray;
        }
        span {
            display: inline-block;
            width: 100%;
            @include font-size(rem(12), rem(0), 400);
            line-height: normal;
            text-align: right;
            color: $color-gray-dot;
        }
    }
    .gray-dot {
        display: inline-block;
        width: 3px;
        height: 3px;
        background-color: $color-primary-gray;
        border-radius: 50%;
        margin-right: rem(8);
    }
    .present-wrap {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 70vh;
      padding: rem(40) rem(20) rem(0);
      border-radius: rem(24) rem(24) 0 0;
      background-color: $color-white;
      overflow-y: scroll;
      z-index: 100;
      em {
        display: block;
        margin-bottom: rem(16);
        @include font-size(rem(16), rem(24), 700);
        letter-spacing: -0.8px;
        color: $color-black;
      }
      input {
        width: 100%;
        padding: rem(16);
        margin-bottom: rem(8);
        border: 1px solid $color-gray-500;
        border-radius: rem(6);
        @include font-noto-sans;
        @include font-size(rem(16), rem(0), 400);
        line-height: normal;
        color: $color-black-400;
        &:last-of-type { margin-bottom: 0;}
      }
      p {
        display: flex;
        align-items: center;
        margin-top: rem(12);
        margin-bottom: rem(20);
        @include font-size(rem(13), rem(21), 400);
        color: $color-black-100;
      }
    }

</style>